import React from 'react'

export interface GuideSectionProps {
  title: string
  children: React.ReactNode
  id?: string
}

export default function GuideSection({ title, children, id }: GuideSectionProps) {
  return (
    <section id={id} className="rounded-xl border border-border/60 bg-white p-6 shadow-sm space-y-3">
      <h2 className="text-sm font-semibold text-foreground">{title}</h2>
      {children}
    </section>
  )
}
